<div class="stepper-container">
  <div class="stepper">
    <div>
      
    </div>
    <div 
      *ngFor="let step of steps; let i = index" 
      class="step-item"
      [class.completed]="step.status === 'completed'"
      [class.active]="step.status === 'active'"
      [class.inactive]="step.status === 'inactive'"
    >
    <div class="step-title">{{ step.title }}</div>
      <div class="step-circle">
         
        <svg 
          *ngIf="step.status === 'completed'" 
          class="check-icon" 
          viewBox="0 0 20 20" 
          fill="currentColor"
        >
          <path 
            fill-rule="evenodd" 
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" 
            clip-rule="evenodd" 
          />
        </svg>
        <svg  *ngIf="step.status === 'pending' "
         xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
  <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
  <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
</svg>
        <!-- <span *ngIf="step.status !== 'completed'" class="step-number">{{ i + 1 }}</span> -->
      </div>
     
      <div *ngIf="i < steps.length - 1" class="step-connector"></div>
    </div>
  </div>
</div>